import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const NotificationsCountSubscription = () =>
  import(/* webpackChunkName: "4-feat-realtime" */ './NotificationsCountSubscription');

const LoadableNotificationsCountSubscription = lazyLoadOnRender({ loader: NotificationsCountSubscription });

export default LoadableNotificationsCountSubscription;
